import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

// Heart on vendor pages: adds/removes the vendor from the couple's Saved Vendors shortlist.
export function SaveVendorButton({ pageId, user, dark = true }) {
  const nav = useNavigate();
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (user && pageId) api.get(`/saved-vendors/${pageId}/status`).then((r) => setSaved(r.data.saved)).catch(() => {}); }, [user, pageId]);
  const toggle = async () => {
    if (!user) { nav(`/login?next=${encodeURIComponent(window.location.pathname)}`); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/saved-vendors/${pageId}/toggle`);
      setSaved(data.saved);
      toast.success(data.saved ? "Saved to your vendor shortlist" : "Removed from your shortlist", data.saved ? { action: { label: "View", onClick: () => nav("/dashboard/saved-vendors") } } : undefined);
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  const base = dark ? (saved ? "bg-rose-500 text-white border-rose-500" : "bg-white/10 text-white border-white/25 hover:bg-white/20") : (saved ? "bg-rose-500 text-white border-rose-500" : "bg-white text-[#1C1917] border-[var(--line)] hover:border-rose-400");
  return (
    <button onClick={toggle} disabled={busy} aria-label={saved ? "Remove from saved vendors" : "Save vendor"} className={`rounded-full px-5 py-2.5 text-sm font-semibold inline-flex items-center gap-2 border transition-colors ${base}`} data-testid={`save-vendor-btn-${pageId}`}>
      <Heart className={`w-4 h-4 transition-transform ${saved ? "fill-current scale-110" : ""}`} />{saved ? "Saved" : "Save"}
    </button>
  );
}
